import axios from 'axios';
import { rateLimiter } from './simpleRateLimiter';
import { getAuth } from 'firebase/auth';

export const fetchBooks = async (query, userId) => {
    // Get current user if userId not provided
    const auth = getAuth();
    const currentUserId = userId || (auth.currentUser?.uid);

    // Only check rate limit if we have a userId
    if (currentUserId && !rateLimiter.canMakeRequest(currentUserId)) {
        throw new Error("Too many book searches. Please wait a moment before trying again.");
    }

    try {
        console.log('Fetching books with query:', query);
        const response = await axios.get(
            `https://www.googleapis.com/books/v1/volumes?${query}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
        );
        console.log('API Response:', response.data);
        return response.data.items || [];
    } catch (error) {
        console.error('Error fetching books:', error.response?.data || error.message);
        return [];
    }
};
